export const FallWithHarmOptions = [
    { name: 'PatientDeath', description: 'Patient Death' },
    { name: 'Fracture', description: 'Fracture' },
    { name: 'Dislocation', description: 'Dislocation' },
    { name: 'IntracranialInjury', description: 'Intracranial Injury' },
    { name: 'CrushingInjury', description: 'Crushing Injury' },
    { name: 'Burn', description: 'Burn' },
];
